module.exports = __webpack_public_path__ + "static/media/ecos_Raum_18.e2ec3750.jpg";